import React, { Component } from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import data from "./data";
import uuid from "uuid/v4";

class NavItems extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getTitleFromID(id) {
    let index = data.findIndex(el => {
      return el.id === id;
    });
    if (index) {
      return data[index].title;
    } else {
      return "Could not get title information!";
    }
  }

  getCheckMarkFromID(id) {
    let index = data.findIndex(el => {
      return el.id === id;
    });

    let timePeriod;
    if (this.props.data.id === "4") timePeriod = "week";
    else if (this.props.data.id === "5") timePeriod = "twoDays";
    else if (this.props.data.id === "6") timePeriod = "today";
    else if (this.props.data.id === "7") timePeriod = "allTips";

    // It will show 1st level check mark once an item on the 2nd level is checked
    let checkCount = 0;
    if (data[index].content) {
      data[index].content.forEach(checkBoxItem => {
        if (checkBoxItem.text) {
          if (
            this.props.subscription.checkBoxes[timePeriod][
              checkBoxItem.text
            ] === true
          )
            checkCount++;
        }
      });
    }
    return (
      <>
        {checkCount > 0 ? <i className="far fa-check-circle fa-fw"></i> : null}
      </>
    );
  }

  render() {
    let renderText;
    if (this.props.data.id === "4")
      renderText = "Since your court date is over one week away, be sure you:";
    else if (this.props.data.id === "5")
      renderText = "Since your court date is two days away, be sure you:";
    else if (this.props.data.id === "6")
      renderText = "Since your court date is today, be sure you:";
    else if (this.props.data.id === "7")
      renderText = "Select each testimony prep tip to view details.";
    else
      renderText = "Check off what you have done and see why it’s important.";

    return (
      <>
        <p id="textAboveChoice">{renderText}</p>
        <ListGroup>
          {this.props.data.navOptions.map(navID => {
            return (
              <ListGroupItem
                onClick={() => {
                  this.props.navTo(navID);
                }}
                tag="li"
                key={uuid()}
              >
                {this.getCheckMarkFromID(navID)}
                {this.getTitleFromID(navID)}
              </ListGroupItem>
            );
          })}
        </ListGroup>
      </>
    );
  }
}

export default NavItems;
